import { Container } from '@mui/material';
import Hero from './components/Hero';
import ServicesGrid from './components/ServicesGrid';

export default function Home() {
  return (
    <main>
      <Hero />
      <Container maxWidth="lg">
        <ServicesGrid />
      </Container>
    </main>
  );
}